import apiService from "@/../api/rest";

/**
 * Fetchs all feature flags from the node layer and sets them in app state
 */
export const fetchFeatureFlags = async ({ commit, getters }) => {
    const customSegmentationFields = getters.getCustomSegmentationFields;
    const { data: featureFlags } = await apiService.getFeatureFlags(customSegmentationFields);
    
    commit("setFeatureFlags", featureFlags);
};
/**
 * Returns all flags contained in flagIds and updates app state with the new values received
 * @param flagIds format flag1,flag2,flag3
 * @returns {{ Promise<{ [key: string]: boolean }>}}
 */
export const fetchFeatureFlagsById = async ({ commit, getters, state }, flagIds: string): Promise<{ [key: string]: boolean }> => {
  const customSegmentationFields = getters.getCustomSegmentationFields;
  const { data: featureFlags } = await apiService.getFeatureFlags(customSegmentationFields, flagIds);

  //Append feature flags received from the node layer to existing feature flags in app state
  commit("setFeatureFlags", { ...state.featureFlags, ...featureFlags });

  return featureFlags;
};
